import { jsx as _jsx } from "react/jsx-runtime";
import './Component_ResourceManager.scss';
import React from 'react';
export class Component_ResourceManager extends React.Component {
    render() {
        return _jsx("div", { className: 'placeholder-page-message', children: "Resource Manager" });
    }
}
//# sourceMappingURL=Component_ResourceManager.js.map